import { navigateTo } from 'gatsby';
import React from 'react';
import mapContextToProps from 'react-context-toolbox/mapContextToProps';
import { FormattedMessage } from 'react-intl';

import RegisterUserWithReservation from '../mutations/RegisterUserWithReservation';
import paths from '../paths';
import createAccountSchema from '../schema/createAccount';
import { ApiContext } from './ApiProvider';
import { AuthContext } from './AuthWrapper';
import Form from './Form';
import Heading from './Heading';
import { InterstitialForm, InterstitialHeader } from './Interstitial';

const propTypes = {};

// @reach/Router checks autoFocus
const autoFocus = ref => {
  ref?.focus();
};

class CreateAccountForm extends React.Component {
  state = {
    errors: {},
  };

  handleSubmit = async ({ password }) => {
    const { client, email, token, login } = this.props;

    const {
      registerUserWithReservationOrError: { errorMessage },
    } = await RegisterUserWithReservation.commit(client, {
      password,
      token,
    });
    if (errorMessage) {
      this.setState({
        errors: { root: [errorMessage] },
      });
      return;
    }

    await login(email, password);

    navigateTo(paths.bundle);
  };

  handleError = errors => {
    this.setState({ errors });
  };

  render() {
    const { email, isDeviceOnly } = this.props;
    const { errors } = this.state;

    if (isDeviceOnly) return null;

    return (
      <>
        <InterstitialHeader>
          <Heading level="1">
            <FormattedMessage
              id="createAccount.header"
              defaultMessage="Create an Account"
            />
          </Heading>
        </InterstitialHeader>
        <InterstitialForm
          schema={createAccountSchema}
          defaultValue={{ email }}
          submitForm={this.handleSubmit}
          errors={errors}
          onError={this.handleError}
        >
          <Form.FieldGroup
            readOnly
            name="email"
            type="email"
            label={
              <FormattedMessage
                id="createAccount.email"
                defaultMessage="Email"
              />
            }
            alwaysShowLabel
          />

          <Form.FieldGroup
            name="password"
            type="password"
            inputRef={autoFocus}
            label={
              <FormattedMessage
                id="createAccount.password"
                defaultMessage="Create a Password"
              />
            }
            alwaysShowLabel
          />
          <Form.FieldGroup
            name="confirmPassword"
            type="password"
            label={
              <FormattedMessage
                id="createAccount.confirmPassword"
                defaultMessage="Confirm Password"
              />
            }
            alwaysShowLabel
          />

          <Form.SubmitButton disableOnSubmit>
            <FormattedMessage
              id="createAccount.submit"
              defaultMessage="Create Account"
            />
          </Form.SubmitButton>

          <Form.Message for="root" />
        </InterstitialForm>
      </>
    );
  }
}

CreateAccountForm.propTypes = propTypes;

export default mapContextToProps(
  [AuthContext, ApiContext],
  ({ login }, client) => ({
    login,
    client,
  }),
  CreateAccountForm,
);
